module.exports = __webpack_public_path__ + "img/images_homebanner_3_3.2a6f3c2e.png";